// © 2015-2021 WDNA - All Rights Reserved

import _ from 'lodash';
import * as React from 'react';

import { VariableDO } from '../../requests';

interface Props {
  formValues: {
    data: Partial<VariableDO>;
  };
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Function to generate a form component
 *
 * @param props properties of the component
 * @returns jsx element with the form
 */
export default function Form(props: Props): JSX.Element {
  const { data } = props.formValues;
  const isNew: boolean = (data.id === undefined || isNaN(data.id));

  return (
    <fieldset>
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Name</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.name"
            name="data.name"
            value={_.defaultTo(data.name, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Name"
            required
          />
        </div>
        <div className="col-6">
          <label className="label">
            <b>Code</b> &nbsp;{' '}
          </label>
          <input
            type="text"
            id="data.value"
            name="data.value"
            value={_.defaultTo(data.value, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Code"
            required
            readOnly={!isNew}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-6">
          <label className="label">
            <b>Unit</b> &nbsp;
          </label>
          <input
            type="text"
            id="data.unit"
            name="data.unit"
            value={_.defaultTo(data.unit, '')}
            onChange={props.onChange}
            className="input-mandatory"
            style={{ width: '80%' }}
            placeholder="Unit"
            required
          />
        </div>
        <div className="col-3">
          <label className="label">
             &nbsp;
          </label>
          <input
            type="checkbox"
            id="data.graph"
            name="data.graph"
            checked={data.graph || false}
            onChange={props.onChange}
            className="input-new"
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Plottable
          </label>
        </div>
        <div className="col-3">
          <label className="label">
             &nbsp;
          </label>
          <input
            type="checkbox"
            id="data.alarm"
            name="data.alarm"
            checked={data.alarm || false}
            onChange={props.onChange}
            className="input-new"
          />
          &nbsp;&nbsp;
          <label className="label" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            Allow Alarm
          </label>
        </div>
      </div>
    </fieldset>
  );
}
